module.exports = __webpack_public_path__ + "img/03.c5f82ca3.jpg";